enum CarrierTypeValue {
  // 手機載具
  PHONECODE = 2,
  // 自然人憑證
  NATURALCODE = 1,
  // 會員載具
  URMART = 0,
  // 後台現無以下發票類型的載具邏輯，先暫時註解
  // 三聯式電子發票
  // B2B = 0,
  // 捐贈憑證
  // DONATION = 0,
}

export const URMART_CARRIER_NUMBER = "FastRetain";

export default CarrierTypeValue;
